import { Column, Grid } from '../types/grid';
import { computed } from '@angular/core';
import { GridDataSource } from '../types/grid-data-source';
import { Formatter, formatter } from '@softline/ui-core';
import { GridRef } from '../types/refs';

export function grid<TRow extends object>(
  dataSource: GridDataSource<TRow>,
  factory: (ref: GridRef<TRow>) => void): Grid<TRow> {
  const f = formatter();
  const columns = computed(() => {
    const ref: GridRef<TRow> = new GridRef<TRow>(dataSource, f);
    factory(ref);
    return ref.columns;
  })
  return {
    dataSource,
    columns,
  }
}
